import '../../../models/add-to-cart/add-to-cart.js';
import '../../../models/cart/cart.js';
import { SubscriptionType } from '../../../models/subscription/subscription-details.js';
import '../../../models/checkoutState/checkoutState.js';

const getSubscriptionLabels = (subscriptionType, labels)=>{
    switch(subscriptionType){
        case SubscriptionType.MONTHLY:
            return {
                totals: labels.totalPerMonth,
                explainer: labels.subscriptionExplainer.monthly
            };
        case SubscriptionType.QUARTERLY:
            return {
                totals: labels.totalPerThreeMonths,
                explainer: labels.subscriptionExplainer.quarterly
            };
        case SubscriptionType.MIXED_MONTHLY:
            return {
                totals: labels.totalPerMonth,
                explainer: labels.subscriptionExplainer.mixedMonthly
            };
        case SubscriptionType.MIXED_QUARTERLY:
            return {
                totals: labels.totalPerThreeMonths,
                explainer: labels.subscriptionExplainer.mixedQuarterly
            };
    }
};

export { getSubscriptionLabels };
//# sourceMappingURL=get-subscription-labels.js.map
